<div class="loading-background" *ngIf="show">
  <img
    class="shimmer"
    [class.custom-logo]="(config$ | async)?.uiConfiguration?.loadingImage"
    width="100"
    height="100"
    [src]="(config$ | async)?.uiConfiguration?.loadingImage"
  />
</div>
